import React, { useState, useEffect } from "react";
import {
    Container,
    Row,
    Col,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    FormGroup
} from "reactstrap";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { insertInquiry } from "../../api/inquiryService";
import { GetMyCart, CartDelete } from "../../api/cartService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddToCart = () => {
    document.title = "Add To Cart";

    const [cartItems, setCartItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const [remark, setRemark] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        fetchCartItems();
    }, []);

    const fetchCartItems = async () => {
        try {
            setLoading(true);
            const response = await GetMyCart();
            const rows = response?.ROW;

            if (Array.isArray(rows)) {
                const transformedItems = rows.map(item => ({
                    productId: item.STYLE_ID,
                    name: item.DESCRIPTION || "-",
                    metal: item.GOLDCOLORNAME,
                    image: item.RD_IMAGEURL,
                    QUANTITY: 1,
                    selected: false,
                    Style_ID: item.STYLE_ID,
                    Rate: item.RATE,
                    Amount: item.CARTRATE,
                    Cart_ID: item.CART_ID
                }));
                setCartItems(transformedItems);
                localStorage.setItem("cartItems", JSON.stringify(transformedItems));
            } else {
                setCartItems([]);
            }

        } catch (error) {
            setCartItems(JSON.parse(localStorage.getItem("cartItems")) || []);
        } finally {
            setLoading(false);
        }
    };

    const toggleSelect = (productId) => {
        setCartItems(prev =>
            prev.map(item =>
                item.productId === productId ? { ...item, selected: !item.selected } : item
            )
        );
    };

    const changeQty = (productId, type) => {
        setCartItems(prev =>
            prev.map(item =>
                item.productId === productId
                    ? {
                        ...item,
                        QUANTITY:
                            type === "inc"
                                ? item.QUANTITY + 1
                                : item.QUANTITY > 1
                                    ? item.QUANTITY - 1
                                    : 1
                    }
                    : item
            )
        );
    };

    const openDeleteModal = (productId) => {
        setItemToDelete(productId);
        setDeleteModalOpen(true);
    };

    const confirmDelete = async () => {
        try {
            const item = cartItems.find(x => x.productId === itemToDelete);
            if (!item) return;

            const request = {
                Cart_ID: item.Cart_ID?.toString(),
                Style_ID: item.Style_ID?.toString(),
                Party_ID: ""
            };

            await CartDelete(request);

            const updated = cartItems.filter(x => x.productId !== itemToDelete);
            setCartItems(updated);
            localStorage.setItem("cartItems", JSON.stringify(updated));
            window.dispatchEvent(new Event("cartUpdated"));

            setDeleteModalOpen(false);
            setItemToDelete(null);
        } catch {
            alert("Failed to remove item.");
        }
    };

    const handleSelectAll = () => {
        const allSelected = cartItems.every(item => item.selected);
        setCartItems(prev => prev.map(item => ({ ...item, selected: !allSelected })));
    };

    const handleInquireNow = () => {
        const selected = cartItems.filter(item => item.selected);
        if (selected.length > 0) setModalOpen(true);
        else alert("Please select at least one product to inquire.");
    };


    const handleSubmitInquiry = async () => {
        const selected = cartItems.filter(item => item.selected);

        const styles = selected.map(item => ({
            Style_ID: item.Style_ID.toString(),
            StyleNo: item.name || ""
        }));

        const payload = {
            Customer_ID: "8447",
            Remark: remark,
            Styles: styles
        };

        console.log("Payload to send:", payload);

        try {
            const response = await insertInquiry(payload);
            console.log("API response:", response);

            // Success notifications
            if (response?.ROW && response.ROW.length > 0) {
                toast.success(`Inquiry submitted!`, {
                    theme: "colored",
                    position: "top-right",
                    autoClose: 3000
                });
            } else if (response?.ZMESSAGE?.length > 0) {
                toast.error(response.ZMESSAGE.map(m => m.MESSAGE).join("\n"), {
                    theme: "colored",
                    position: "top-right",
                    autoClose: 5000
                });
            } else {
                toast.success("Inquiry submitted successfully!", {
                    theme: "colored",
                    position: "top-right",
                    autoClose: 3000
                });
            }

            setModalOpen(false);
        } catch (error) {
            console.error("Inquiry Error:", error);

            const errorMessage = error?.response?.data?.message || "Failed to submit inquiry";
            toast.error(errorMessage, {
                theme: "colored",
                position: "top-right",
                autoClose: 5000
            });
        }
    };




    const removeFromInquiry = (productId) => {
        setCartItems(prev =>
            prev.map(item =>
                item.productId === productId ? { ...item, selected: false } : item
            )
        );
    };

    const selectedItems = cartItems.filter(item => item.selected);

    const columns = [
        {
            name: (
                <div className="text-center w-100">
                    <FormGroup check className="m-0 d-inline-block">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            checked={cartItems.length > 0 && cartItems.every(item => item.selected)}
                            onChange={handleSelectAll}
                        />
                    </FormGroup>
                </div>
            ),
            cell: row => (
                <FormGroup check className="m-0">
                    <input
                        type="checkbox"
                        className="form-check-input"
                        checked={row.selected}
                        onChange={() => toggleSelect(row.productId)}
                    />
                </FormGroup>
            ),
            width: "80px",
            style: { justifyContent: "center" },
        },
        {
            name: "Product",
            cell: row => (
                <div className="d-flex align-items-center">
                    <div className="product-image-placeholder me-3">
                        {row.image ? (
                            <img
                                src={row.image}
                                alt={row.name}
                                style={{ width: 150, height: 150, objectFit: 'cover', borderRadius: 6 }}
                            />
                        ) : (
                            <img
                                src="/assets/images/binstock/no-image.jpg"
                                alt={row.name}
                                style={{ width: 150, height: 150, objectFit: 'cover', borderRadius: 6 }}
                            />
                        )}
                    </div>
                    <div>
                        <div className="fw-bold fs-4">{row.name}</div>
                    </div>
                </div>
            ),
            width: "400px"
        },
        {
            name: <div className="text-center w-100">Quantity</div>,
            cell: row => (
                <div className="d-flex align-items-center justify-content-center">
                    <Button color="outline-primary" size="sm" onClick={() => changeQty(row.productId, "dec")}>-</Button>
                    <span className="mx-3">{row.QUANTITY}</span>
                    <Button color="outline-primary" size="sm" onClick={() => changeQty(row.productId, "inc")}>+</Button>
                </div>
            ),
            style: { justifyContent: "center" },
        },
        {
            name: <div className="text-center w-100">Action</div>,
            cell: row => (
                <Button color="link" className="p-0" style={{ fontSize: 25 }} onClick={() => openDeleteModal(row.productId)}>
                    <i className="bx bx-trash"></i>
                </Button>
            ),
            width: "150px",
            style: { justifyContent: "center" },
        }
    ];

    const customStyles = {
        headCells: {
            style: {
                backgroundColor: "#f8f9fa",
                fontWeight: "bold",
                fontSize: "15px",
                padding: "12px 5px"
            }
        },
        cells: {
            style: {
                fontSize: "14px",
                padding: "12px 8px"
            }
        }
    };

    if (loading) {
        return (
            <Container className="py-4">
                <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status"></div>
                    <p className="mt-3">Loading your cart...</p>
                </div>
            </Container>
        );
    }

    return (
        <Container className="py-4">
            <Row>
                <Col>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h3 className="mb-0 fs-5">My Cart ({cartItems.length} items)</h3>
                        <Button color="primary" onClick={handleInquireNow} disabled={selectedItems.length === 0}>
                            Inquire Now ({selectedItems.length})
                        </Button>
                    </div>

                    {cartItems.length === 0 ? (
                        <div className="text-center py-5">
                            <h4>Your cart is empty</h4>
                            <Button color="primary" onClick={() => navigate("/bin-stock")}>Continue Shopping</Button>
                        </div>
                    ) : (
                        <DataTable
                            columns={columns}
                            data={cartItems}
                            customStyles={customStyles}
                            highlightOnHover
                            striped
                            responsive
                            pagination
                            paginationPerPage={5}
                            paginationRowsPerPageOptions={[5, 10, 15, 20]}
                            dense
                        />
                    )}

                    <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)} size="lg">
                        <ModalHeader toggle={() => setModalOpen(false)}>Product Inquiry ({selectedItems.length} items)</ModalHeader>
                        <ModalBody>
                            <Row>
                                {selectedItems.map(product => (
                                    <Col md={6} lg={3} key={product.productId} className="mb-3">
                                        <div className="card border-0 shadow-sm h-100 position-relative bg-white rounded">
                                            <Button color="link" className="position-absolute top-0 end-0 p-1 m-0" onClick={() => removeFromInquiry(product.productId)}>x</Button>
                                            <div className="card-body p-3">
                                                <h6 className="fw-bold mb-2 text-truncate fs-5" title={product.name}>
                                                    {product.name}
                                                </h6>
                                                <p className="text-muted mb-2 small fs-6">
                                                    <i className="bx bx-calendar me-1"></i>
                                                    {new Date().toLocaleDateString("en-GB")}
                                                </p>
                                                <p className="text-muted mb-0 small fs-6">
                                                    {product.QUANTITY} {product.QUANTITY === 1 ? "Product" : "Products"}
                                                </p>
                                            </div>
                                        </div>
                                    </Col>
                                ))}
                            </Row>

                            <div className="inquiry-form mt-4">
                                <FormGroup>
                                    <div className="mb-3">
                                        <label className="form-label">Remark: </label>
                                        <textarea
                                            className="form-control bg-white"
                                            rows="3"
                                            placeholder="Additional information or remarks..."
                                            value={remark}
                                            onChange={(e) => setRemark(e.target.value)}
                                        />
                                    </div>
                                </FormGroup>
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={() => setModalOpen(false)}>Cancel</Button>
                            <Button color="primary" onClick={handleSubmitInquiry}>Submit Inquiry</Button>
                        </ModalFooter>
                    </Modal>

                    <Modal isOpen={deleteModalOpen} toggle={() => setDeleteModalOpen(false)} centered>
                        <ModalHeader toggle={() => setDeleteModalOpen(false)}>Confirm Delete</ModalHeader>
                        <ModalBody className="text-center">
                            Are you sure you want to delete this product?
                        </ModalBody>
                        <ModalFooter className="justify-content-center">
                            <Button color="secondary" onClick={() => setDeleteModalOpen(false)}>Cancel</Button>
                            <Button color="primary" onClick={confirmDelete}>Delete</Button>
                        </ModalFooter>
                    </Modal>
                </Col>
            </Row>
            {/* ToastContainer is required for react-toastify to display notifications */}
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
        </Container>
    );
};

export default AddToCart;
